module.exports = __webpack_public_path__ + "media/images/icons/flags/GE-ae1e0e8b79d6add91ccd31c529d5b904.svg";